import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckSquare = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 15 15",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M11.25 1.875H3.75C2.71447 1.875 1.875 2.71447 1.875 3.75V11.25C1.875 12.2855 2.71447 13.125 3.75 13.125H11.25C12.2855 13.125 13.125 12.2855 13.125 11.25V3.75C13.125 2.71447 12.2855 1.875 11.25 1.875Z",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M5 7.5L6.875 9.375L10 5.625",
		stroke: "currentColor",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgCheckSquare;
